export const setValor = value => ({ type: 'setValor', value }); //se debe agregar el export al const 
export const setCuenta = value => ({ type: 'setCuenta', value });
export const resetCuenta = value => ({ type: 'resetCuenta', value });


export const setTerceroCuentas = value => ({ type: 'setTerceroCuentas', value });
export const resetTerceroCuentas = value => ({ type: 'resetTerceroCuentas', value });
export const loadingTerceroCuentas = value => ({ type: 'loadingTerceroCuentas', value });

//SnackBar
export const openSnackBar = value => ({ type: 'openSnackBar', value });
export const openConfirmSnackBar = (value, post) => ({ type: 'openConfirmSnackBar', value, post });
export const closeSnackBar = value => ({ type: 'closeSnackBar', value });

export const setContadorDetalle = value => ({ type: 'setContadorDetalle', value });
export const setContadorDetalleMes = value => ({ type: 'setContadorDetalleMes', value });
export const setContadorDetalleDia = value => ({ type: 'setContadorDetalleDia', value });

//Post Acciones

export const sendPost = () => ({ type: 'sendPost' });
export const initPost = () => ({ type: 'initPost' });
export const setPost = value => ({ type: 'setPost', value });

//Login
export const setAuthLogin = value => ({ type: 'LOG_IN', value });
export const setAuthLogout = value => ({ type: 'LOG_OUT', value });

export const initFrmLogin = () => ({ type: 'initFrmLogin' });
export const fetchingFrmLogin = () => ({ type: 'fetchingFrmLogin' });
export const doneFrmLogin = () => ({ type: 'doneFrmLogin' });

//FrmConsutlas //OJO tienen que ir en el apiFetch
export const initFrmConsulta = () => ({ type: 'initFrmConsulta' });
export const fetchingFrmConsulta = () => ({ type: 'fetchingFrmConsulta' });
export const doneFrmConsulta = () => ({ type: 'doneFrmConsulta' });

export const setProcesos = value => ({ type: 'setProcesos', value });

//autoCompletar
export const setCodProcesoLst = value => ({ type: 'setCodProcesoLst', value });
export const setMagistradoLst = value => ({ type: 'setMagistradoLst', value });
export const setDemandanteLst = value => ({ type: 'setDemandanteLst', value });
export const setDemandadoLst = value => ({ type: 'setDemandadoLst', value });
export const setInstanciaLst = value => ({ type: 'setInstanciaLst', value });
export const setAccionLst = value => ({ type: 'setAccionLst', value });
export const setDescriptorLst = value => ({ type: 'setDescriptorLst', value });
export const setRestrictorLst = value => ({ type: 'setRestrictorLst', value });
export const setDecisionLst = value => ({ type: 'setDecisionLst', value });

export const setCuentaCodigo = value => ({ type: 'setCuentaCodigo', value });

export const setCuentaDetalleContador = value => ({ type: 'setCuentaDetalleContador', value });
export const resetCuentaDetalleContador = value => ({ type: 'resetCuentaDetalleContador', value });

export const setPeriodo = value => ({ type: 'setPeriodo', value });
export const resetPeriodo = value => ({ type: 'resetPeriodo', value });

export const setMes = value => ({ type: 'setMes', value });
export const resetMes = value => ({ type: 'resetMes', value });

export const setTipoRegistro = value => ({ type: 'setTipoRegistro', value });

export const initApiFetch = value => ({ type: 'initApiFetch', value });
export const fetchingApiFetch = value => ({ type: 'fetchingApiFetch', value });
export const doneApiFetch = value => ({ type: 'doneApiFetch', value });

export const initFrmTerceroCuentasTmp = () => ({ type: 'initFrmTerceroCuentasTmp' });
export const fetchingFrmTerceroCuentasTmp = () => ({ type: 'fetchingFrmTerceroCuentasTmp' });
export const doneFrmTerceroCuentasTmp = () => ({ type: 'doneFrmTerceroCuentasTmp' });



export const initRptCtasDetalles = () => ({ type: 'initRptCtasDetalles' });
export const fetchingRptCtasDetalles = () => ({ type: 'fetchingRptCtasDetalles' });
export const doneRptCtasDetalles = () => ({ type: 'doneRptCtasDetalles' });

export const initRptCtasDetallesMes = () => ({ type: 'initRptCtasDetallesMes' });
export const fetchingRptCtasDetallesMes = () => ({ type: 'fetchingRptCtasDetallesMes' });
export const doneRptCtasDetallesMes = () => ({ type: 'doneRptCtasDetallesMes' });

export const initRptCtasDetallesDia = () => ({ type: 'initRptCtasDetallesDia' });
export const fetchingRptCtasDetallesDia = () => ({ type: 'fetchingRptCtasDetallesDia' });
export const doneRptCtasDetallesDia = () => ({ type: 'doneRptCtasDetallesDia' });


//Edicion
export const setEditarProvidencia = value => ({ type: 'setEditarProvidencia', value });
export const setNuevaProvidencia = value => ({ type: 'setNuevaProvidencia', value });



